import Vue from 'vue';
import Main from './main.vue';
let TipsConstructor = Vue.extend(Main);
let instance;
var Message = function (options) {
  options = options || {};
  if (typeof options === 'string') {
    options = {
      message: options
    };
  }
  instance = new TipsConstructor({
    data: options
  });
  instance.vm = instance.$mount();
  document.body.appendChild(instance.vm.$el);
  instance.vm.visible = true;
  instance.dom = instance.vm.$el;
  instance.dom.style.zIndex = 10000;
  console.log(instance.vm.$el);
};

export default Message;



// WEBPACK FOOTER //
// ./src/components/tips/main.js